import { Navigate } from "react-router-dom";

const PrivateRoute = (props) => {
  const authed = localStorage.getItem('accessToken') // isauth() returns true or false based on localStorage

  return props.access || authed ? props.children : <Navigate to="/login" />;
};
export default PrivateRoute;
